import { render, staticRenderFns } from "./CopyMoveReportModal.vue?vue&type=template&id=dbbc24aa&scoped=true"
import script from "./CopyMoveReportModal.vue?vue&type=script&lang=js"
export * from "./CopyMoveReportModal.vue?vue&type=script&lang=js"
import style0 from "./CopyMoveReportModal.vue?vue&type=style&index=0&id=dbbc24aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbc24aa",
  null
  
)

export default component.exports